document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq__questions-tab-button').forEach(button => {
        button.addEventListener('click', () => {
            const target = document.getElementById(button.getAttribute('data-toggle'));
            if (!target) return;

            const isExpanded = target.classList.contains('show');
            const icon = button.querySelector('.icon-toggle');
            if (icon) {
                icon.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
                icon.textContent = isExpanded ? '+' : '-';
            }

            if (isExpanded) {
                target.style.height = '0';
                target.addEventListener('transitionend', () => {
                    target.classList.remove('show');
                }, { once: true });
            } else {
                target.classList.add('show');
                target.style.height = target.scrollHeight + 'px';
            }
        });
    });
});